import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';

import {
  Box,
  Card,
  CardContent,
  Button,
  Typography,
  Grid,
} from '@mui/material';

import { login, register } from '../../utils/helper';

import { SignIn } from '../../components/HomePage/SignIn/SignIn';
import { styles } from './styles';
import { Register } from '../../components/HomePage/Register';
import { RegisterRequest, Role } from '../../utils/types';

export const Login = () => {
  const navigate = useNavigate();
  const { setLoggedIn, setId, setRole, setEmail, setUsername, setJwt, jwt } = useAuth();
  const [loginUsername, setLoginUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [newAccount, setNewAccount] = useState<boolean>(false);
  const [loginEmail, setLoginEmail] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    if (!loginUsername || !password) {
      setError('Please fill in all fields');
      return;
    }

    if (newAccount) {
      const requestBody: RegisterRequest = {
        username: loginUsername,
        password,
        email: loginEmail,
        role: Role.USER,
        isActive: true
      };
      try {
        await register(requestBody, jwt);
        setNewAccount(false);
      } catch (error) {
        setError('Registration failed. Please try again.');
      }
      return;
    }

    try {
      const { userId, role, email, username, jwtToken } = await login({ username: loginUsername, password }, jwt);
      setLoggedIn(true);
      setId(userId);
      setRole(role);
      setEmail(email);
      setUsername(username);
      setJwt(jwtToken);
      navigate('/dashboard');
    } catch (error) {
      setError('Invalid Login');
    }
  };

  return (
    <Box sx={styles.box}>
      <Card variant="outlined" sx={styles.card}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h4" align="center" gutterBottom sx={styles.header}>
            Login
          </Typography>
          {error && (
            <Typography color="error" align="center" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {!newAccount ? (
              <SignIn
                username={loginUsername}
                setUsername={setLoginUsername}
                password={password}
                setPassword={setPassword}
                showPassword={showPassword}
                setShowPassword={setShowPassword}
              />
            ) : (
              <Register
                username={loginUsername}
                setUsername={setLoginUsername}
                password={password}
                setPassword={setPassword}
                showPassword={showPassword}
                setShowPassword={setShowPassword}
                email={loginEmail}
                setEmail={setLoginEmail}
              />
            )}
            <Grid container spacing={2}>
              <Grid size={6}>
                <Button type="submit" variant="outlined" color="primary" fullWidth sx={styles.blueButton}>
                  {newAccount ? 'Create Account' : 'Sign In'}
                </Button>
              </Grid>
              <Grid size={6}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  sx={styles.greenButton}
                  onClick={() => setNewAccount(!newAccount)}
                >
                  Register
                </Button>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
